import React from 'react';
import ReactDOM from 'react-dom/client';
import { PrivyProvider } from '@privy-io/react-auth';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { env } from '@rmint/shell';
import './styles/tailwind.css';

const root = ReactDOM.createRoot(document.getElementById('root')!);
const routerTree = <RouterProvider router={router} />;

// Admin signs no on-chain txs → no SmartWalletsProvider, no viem chain config,
// no widget registry. PrivyProvider only when a real appId is configured;
// dev-bypass renders without it (useAuth returns the admin stub).
const tree = env.privyAppId ? (
  <PrivyProvider
    appId={env.privyAppId}
    config={{ loginMethods: ['email', 'wallet'], appearance: { theme: 'light' } }}
  >
    {routerTree}
  </PrivyProvider>
) : (
  routerTree
);

root.render(<React.StrictMode>{tree}</React.StrictMode>);
